import Vue from 'vue'
import VueRouter from 'vue-router'
import getPageTitle from '@/util/get-page-title'
import {isViewLoggedIn} from '@/util/viewAuth'

Vue.use(VueRouter)

const routes = [
	{
		path: '/login',
		name: 'login',
		component: () => import('@/views/MyLogin'),
		meta: {title: '登录'}
	},
	{
		path: '/',
		component: () => import('@/views/Index'),
		redirect: '/home',
		children: [
			{
				path: '/home',
				name: 'home',
				component: () => import('@/views/home/Home'),
				meta: {title: '首页'}
			},
			{
				path: '/archives',
				name: 'archives',
				component: () => import('@/views/archives/Archives'),
				meta: {title: '归档'}
			},
			{
				path: '/blog/:id',
				name: 'blog',
				component: () => import('@/views/blog/Blog'),
				meta: {title: '博客'}
			},
			{
				path: '/tag/:name',
				name: 'tag',
				component: () => import('@/views/tag/Tag'),
				meta: {title: '标签'}
			},
			{
				path: '/category/:name',
				name: 'category',
				component: () => import('@/views/category/Category'),
				meta: {title: '分类'}
			},
			{
				path: '/moments',
				name: 'moments',
				component: () => import('@/views/moments/Moments'),
				meta: {title: '动态'}
			},
			{
				path: '/friends',
				name: 'friends',
				component: () => import('@/views/friends/Friends'),
				meta: {title: '友人帐'}
			},
			{
				path: '/about',
				name: 'about',
				component: () => import('@/views/about/About'),
				meta: {title: '关于我'}
			},
			{
				path: '/user/center',
				name: 'user-center',
				component: () => import('@/views/user/Center'),
				meta: {title: '个人中心', requiresAuth: true}
			},
			{
				path: '/user/settings',
				name: 'user-settings',
				component: () => import('@/views/user/Settings'),
				meta: {title: '设置', requiresAuth: true}
			}
		]
	}
]

const router = new VueRouter({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

function decodeRedirect(raw, fallback) {
	if (typeof raw !== 'string' || !raw) {
		return fallback
	}
	try {
		return decodeURIComponent(raw)
	} catch (e) {
		return raw
	}
}

router.beforeEach((to, from, next) => {
	const loggedIn = isViewLoggedIn()
	if (to.path === '/login' && loggedIn) {
		const redirect = decodeRedirect(to.query.redirect, '/home')
		next(redirect)
		return
	}

	if (to.matched.some(item => item.meta && item.meta.requiresAuth) && !loggedIn) {
		next({
			path: '/login',
			query: {redirect: to.fullPath}
		})
		return
	}

	document.title = getPageTitle(to.meta.title)
	next()
})

export default router
